import { loaderAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { api } from "../../helpers/api";
import { setLocalStorage } from "../../helpers/LocalStorage";

export const UpdateSlugThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('slug', args.slug);

        const response = await api({ data: formData, link: 'update_slug' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Перезагружаем страницу с новым слагом
            window.location.reload();
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};